import { SignatoryTypeRole } from "src/app/modules/contacts/model/signatory-type-role";

export class SignatoryEdit {
  id: number;
  idAdd?: number;
  name: string;
  ssn: string;
  ssnWithMask: string;
  mail: string;
  subscriberTypeValue: string;
  signatureTypeValue: string;
  order: number;
  checked: boolean;
  status: number;
  signatureTypeSelectedValue: string;
  subscriberType: number;
  signatureType: number;
  envelopeSignatoryId?: number;
  saveTo: boolean;
  phoneNumber: string;
  acceptWhatsApp: boolean;
  sendWhatsApp: boolean;
  reuseSignatures: boolean;
  envelopeRejectedHistory: [];
  isLocalEdit: boolean;
  segments: []
  allSegments: boolean;
  saveJustInEnvelope : boolean = false;
  signatoryTypeRoleId?: number;
  isEdited: boolean = false;
  signatoryTypeRole?: SignatoryTypeRole;
}